/**
 * ProviderConfigSection - Despacha as configurações específicas por providerId.
 *
 * Cada provider de canal pode ter configurações próprias (engine, tokens,
 * webhooks, credenciais). Este componente delega para o config específico
 * do provider, mantendo a EditChannelPage agnóstica de provider.
 *
 * Por enquanto só `gateway-whatsapp` está implementado — outros providers
 * caem no fallback (nada renderizado).
 */

import React from 'react';
import type { ChannelResponse } from '@/modules/channels/types';
import { GatewayWhatsAppConfig } from './GatewayWhatsAppConfig';
import { WhatsAppBusinessConfig } from './WhatsAppBusinessConfig';
import { EmailResendConfig } from './EmailResendConfig';

interface ProviderConfigSectionProps {
  channel: ChannelResponse;
  /** Integração com o "Salvar Alterações" único da página: o config do
   *  provider reporta dirty e registra sua função de save aqui — NÃO existe
   *  botão de salvar próprio dentro dos blocos de provider. */
  onDirtyChange?: (dirty: boolean) => void;
  saveRef?: React.MutableRefObject<(() => Promise<boolean>) | null>;
}

export const ProviderConfigSection: React.FC<ProviderConfigSectionProps> = ({
  channel,
  onDirtyChange,
  saveRef,
}) => {
  switch (channel.providerId) {
    case 'gateway-whatsapp':
      return <GatewayWhatsAppConfig channel={channel} />;
    case 'whatsapp-business':
      return <WhatsAppBusinessConfig channel={channel} />;
    case 'email-resend':
      return <EmailResendConfig channel={channel} onDirtyChange={onDirtyChange} saveRef={saveRef} />;
    default:
      return null;
  }
};

ProviderConfigSection.displayName = 'ProviderConfigSection';